module.exports = __webpack_public_path__ + "media/images/bg/mosaic/pattern-flowers-8e6539099e2d61ff90c7fae7e42fe53c.svg";